var _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgK = function SvgK(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width,
    height: props.height,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: props.viewBox
  }, props), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.491 0h10.814v42.763a15.822 15.822 0 0 0-10.814 0V0Z",
    fill: props.color,
    stroke: props.color
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.898,
    cy: 52.101,
    r: 5.898
  })), /*#__PURE__*/React.createElement("path", {
    d: "m10.814 36.865 18.678-18.924h12.78L22.856 36.865l19.416 19.17h-12.78l-18.678-19.17Z",
    fill: props.color,
    stroke: props.color
  })));
};
export default SvgK;